import { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
} from '@mui/material';

import { apiDelete } from '../../services/genesisApi/httpsMethods';
import { useNavigate } from 'react-router-dom';
import { CustomButton } from './customButton';

interface ConfirmDialogProps {
    open: boolean;
    endpoint: string;
    id: number;
    title?: string;
    description?: string;
    confirmText?: string;
    cancelText?: string;
    onClose: () => void;
    onSuccess?: () => void;
}

export const ConfirmDialog = ({
    open,
    title = "Confirm Action",
    description = "Are you sure you want to proceed?",
    confirmText = "Confirm",
    cancelText = "Cancel",
    endpoint,
    id,
    onClose,
    onSuccess,
}: ConfirmDialogProps) => {
    const navigate = useNavigate();
    const [errorOpen, setErrorOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const handleConfirm = async () => {
        try {
            const result = await apiDelete(endpoint, id);

            if (result && result.success && (result.status === 204 || result.status === 200)) {
                if (onSuccess) {
                    onSuccess();
                } else {
                    navigate('/');
                }
            } else {
                if (result?.status === 409) {
                    setErrorMessage((typeof result.message === 'string' ? result.message : result.message?.message) || 'Failed to delete.');
                } else {
                    setErrorMessage((typeof result?.message === 'string' ? result.message : result?.message?.message) || 'Unexpected error occurred.');
                }
                setErrorOpen(true);
            }
        } catch (err) {
            // Catch unexpected JS/runtime error
            setErrorMessage('Unexpected error occurred.');
            setErrorOpen(true);
        } finally {
            onClose();
        }
    };

    

    const handleCloseError = () => {
        setErrorOpen(false);
    };

    return (
        <>
            <Dialog open={open} onClose={onClose}>
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    <DialogContentText>{description}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <CustomButton
                        handleButtonPress={onClose}
                        isButtonDisabled={false}
                        text={cancelText || "Cancel"}
                        solid={false}
                    />
                    <CustomButton
                        handleButtonPress={handleConfirm}
                        isButtonDisabled={false}
                        text={confirmText || "Delete"}
                        isDeleteButton={true}
                        solid={true}
                    />
                </DialogActions>
            </Dialog>

            <Dialog open={errorOpen} onClose={handleCloseError}>
                <DialogTitle>Delete Failed</DialogTitle>
                <DialogContent>
                    <DialogContentText>{errorMessage}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <CustomButton
                        handleButtonPress={handleCloseError}
                        isButtonDisabled={false}
                        text="Close"
                        solid={false}
                    />
                </DialogActions>
            </Dialog>
        </>
    );
};
